<div class="content">
  <h1>Seeguide App kostenlos herunterladen</h1>

  <div class="badges">
    <div class="appstore">
      <a href="https://apps.apple.com/at/app/id1529068241"><img src="/assets/appstorebadge.svg" alt="appstore badge"></a>
    </div>
    <div class="playstore">
      <a href="https://play.google.com/store/apps/details?id=at.seeguide.app"><img src="/assets/google-play-badge.svg" alt="playstore badge"></a>
    </div>
  </div>
  

  <p class="text">Mit der kostenlosen Seeguide App kannst du immer und überall die besten Plätze und Restaurants rund um den Attersee finden. Natürlich kannst du dich auch einfach zu den Orten navigieren lassen und wenn du möchtest eine Bewertung für andere User abgeben.</p>

  <div class="images">
    <a href="assets/startscreen.png"><img src="assets/startscreen.png" alt="Startseit der iOS App Seeguide.at"></a>
    <a href="assets/bathingPlacesList.png"><img src="assets/bathingPlacesList.png" alt="Liste mit Badeplätzen vom Attersee in der iOS App Seeguide.at"></a>
    <a href="assets/bathingPlacesMap.png"><img src="assets/bathingPlacesMap.png" alt="Karte mit allen Badeplätzen vom Attersee in der iOS App Seeguide.at"></a>
  </div>  
  <br>

  <p class="text">Außerdem gibt es in der App auch noch ein Insider Forum wo du dich mit anderen Usern austauschen kannst und sicherlich noch den ein oder anderen Geheimtipp erfährst.</p>

  <p class="text">Mit unserer übersichtlichen Karte siehst du auch sofort interessante Restaurants oder alle Badeplätze rund um den Attersee. Die App gibt es derzeit natürlich kostenlos zum Downloaden für iOS  und Android Geräte. Das Forum ist derzeit noch exklusiv in der iOS Version.</p>
  <br>
  <div class="badges">
    <div class="appstore">
      <a href="https://apps.apple.com/at/app/id1529068241"><img src="/assets/appstorebadge.svg" alt="appstore badge"></a>
    </div>
    <div class="playstore">
      <a href="https://play.google.com/store/apps/details?id=at.seeguide.app"><img src="/assets/google-play-badge.svg" alt="playstore badge"></a>
    </div>
  </div>
</div>
